module.exports = __webpack_public_path__ + "img/jiance3.49f9ccc6.png";